import { useState } from "react"

type Props = {
  showProjectBoundaryModal: boolean
  setShowProjectBoundaryModal: React.Dispatch<React.SetStateAction<any>>
  csib64: string
  t: any
}
export const EditProjectBoundary: React.FC<Props> = ({ setShowProjectBoundaryModal, csib64, t }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showWarning, setShowWarning] = useState(false)

  const toggleMenu = () => {
    if (!csib64) {
      setShowWarning(true)

      // Automatically dismiss the warning after 2 seconds
      setTimeout(() => {
        setShowWarning(false)
      }, 3000)
      return
    }
    setIsOpen(!isOpen)
  }
  // Function to update state
  const handleOptionClick = () => {
    // Handle click for each option
    setShowProjectBoundaryModal(true)
    setIsOpen(!isOpen)
  }

  return (
    <div>
      <div className="row d-flex flex-row-reverse mx-2">
        <div onClick={toggleMenu} style={{ cursor: "pointer", transform: "scale(0.9,0.9)" }} data-testid="option-icon">
          <i className="icon-font tc-icon-more-vert"></i>
        </div>
      </div>
      {showWarning && (
        <WarningMessage message={t("connectSettings.crsNotFound")} onClose={() => setShowWarning(false)} />
      )}

      {isOpen && (
        <div className="d-flex flex-row-reverse">
          <div className="flex-column">
            <div
              style={{
                background: "transparent",
                boxShadow: "inset 3px 3px 5px rgba(0,0,0,.1), 3px 3px 5px rgba(0,0,0,.1)",
                width: "250px",
                padding: "10px 0",
                textAlign: "center",
                cursor: "pointer",
                marginBottom: "5px"
              }}
              onClick={() => handleOptionClick()}
            >
              {t("connectSettings.inputOption")}
            </div>
            {/* Add more options as needed */}
          </div>
        </div>
      )}
    </div>
  )
}

export const WarningMessage = ({ message, onClose }: { message: string; onClose: () => void }) => {
  // Component to display warning message
  return (
    <div
      className="d-flex justify-content-between"
      style={{
        backgroundColor: "rgba(244, 209, 211, .5)",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "5px",
        fontSize: "16px",
        color: "#a51d25"
      }}
    >
      <p>{message}</p>
      <div onClick={onClose} style={{ cursor: "pointer" }}>
        <i className="icon-font tc-icon-content-close"></i>
      </div>
    </div>
  )
}
